import type { LoginConfig, LoginRequest, LoginResponse, SimpleResponse } from 'pages/authentication/login/types';
import { ApiCaller } from 'apis/ApiCaller';

export class AuthApi {

    private static apiCaller = new ApiCaller('Auth');

    public static GetLoginConfig(): Promise<LoginConfig> {

        return this.apiCaller.GET<LoginConfig>('GetLoginConfig');

    }

    public static Login(data: LoginRequest): Promise<LoginResponse> {

        return this.apiCaller.POST<LoginResponse>('Login', data);

    }

    public static ForgotPassword(email: string): Promise<SimpleResponse> {

        return this.apiCaller.POST<SimpleResponse>('ForgotPassword', { email });

    }

    public static Logout(): Promise<void> {

        return this.apiCaller.GET<void>('Logout');

    }

    public static RecoverUsername(email: string): Promise<SimpleResponse> {

        return this.apiCaller.POST<SimpleResponse>('RecoverUsername', { email });

    }

}
